import Tippy from '@tippyjs/react';
import styled from 'styled-components';
import tw from 'twin.macro';
import { Link } from 'react-router-dom';

export const StyledNavItem = styled.li.attrs((props) => ({
    className: props.className
}))`
    & {
        ${tw`relative`}
        a {
            &.nav-active div {
                ${tw`border-primary`}
            }

            .nav-bottom-line {
                ${tw`absolute bottom-0 left-0 right-0 border-b-4 border-transparent rounded-sm`}
                right: 0.25rem;
                left: 0.25rem;
            }
        }
        
        a:hover {
        .nav-bottom-line {
            ${tw`border-primary-light`}
        }
    }
    }
`;

export const StyledNav = styled.nav.attrs((props) => ({
    className: props.className
}))`
    ${tw`sticky top-0 z-20 flex flex-wrap items-center justify-between w-full p-0 px-3 border-gray-200 shadow-md bg-paper min-h-header md:h-header`}

    .nav-link {
        ${tw`flex items-center px-3 py-2 tracking-wide no-underline uppercase transition-colors duration-300 ease-out md:my-0 h-header`}
    }

    .logo {
        ${tw`mx-2`}
    }

    ul#menu {
        ${tw`block w-full overflow-hidden duration-200 ease-linear divide-y-2 md:items-center md:flex-grow md:divide-y-0 divide-color-primary md:flex md:w-auto transition-max-height`}
        
        .nav-items {
            ${tw`text-sm md:flex-grow md:flex md:flex-row`}
        }

        .nav-action {
            ${tw`hidden text-sm md:justify-end md:flex`}
        }
    }

    .nav-icon {
        ${tw`ml-2 text-color-light`}
    }

    .menu-icon {
        ${tw`flex items-center cursor-pointer md:hidden h-header`}
    }
`;

export const Dropdown = styled(Tippy)`
    & {
        ${tw`py-2 border rounded shadow bg-paper text-color-normal`}

        .tippy-content {
            ${tw`px-0`}
        }
    }
`;

export const DropdownLink = styled(Link)`
    ${tw`px-8 py-2 normal-case hover:bg-primary-light`}
`;